
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/modules/router/router-view.kpa`,
      template: ``,
      style: ``,
      script: `(async () => { "use strict";
return {
    data: {
        currentPath: router.getCurrentPath()
    },
    mounted: function () {
        router.navigate(this.currentPath, true);
    }
};
 })()`
    };
  